import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';

export const Container = superstyled({
  name: 'OneColumnLayout',
  slot: 'Container',
  tag: Stack,
  styles: ({ theme }) => ({
    gap: theme.spacing(3)
  })
});
